import {convertUserName} from 'Common/helpers/convertUserName';
import {IOnlineReportHorseDetails} from 'OnlineReport/models/shared/IOnlineReportHorseDetails';
import {IServerOnlineReportHorseDetails} from '../models/IServerOnlineReportHorseDetails';

export function convertOnlineReportHorseDetails(value: IServerOnlineReportHorseDetails): IOnlineReportHorseDetails {
  return {...value, ownerName: convertUserName(value.ownerFirstName, value.ownerLastName)};
}
